import { useFlowFilter } from '../FlowFilterContext'
import { useDateRangeCtx } from '../DateRangeContext'
import { DateRangeTabs } from '../DateRangeTabs'
import { LeadScoreHistogram } from '../widgets/LeadScoreHistogram'
import { AgeDistribution } from '../widgets/AgeDistribution'
import { GeoTable } from '../widgets/GeoTable'
import { InsuranceMix } from '../widgets/InsuranceMix'
import { TimeToLeadHistogram } from '../widgets/TimeToLeadHistogram'
import { geoCsvUrl, leadScoreCsvUrl } from '../../lib/api'

export function QualitySection() {
  const { range } = useDateRangeCtx()
  const { variantParam, audienceParam } = useFlowFilter()
  return (
    <>
      <div className="section-toolbar">
        <DateRangeTabs />
        <span style={{ flex: 1 }} />
        <a href={leadScoreCsvUrl(range, variantParam, audienceParam)} download className="csv-export">Score-fordeling CSV</a>
        <a href={geoCsvUrl(range, variantParam, undefined, audienceParam)} download className="csv-export">Postnr CSV</a>
      </div>
      <div className="grid-2">
        <LeadScoreHistogram range={range} />
        <AgeDistribution range={range} />
      </div>
      <TimeToLeadHistogram range={range} />
      <div className="grid-2">
        <InsuranceMix range={range} />
        <GeoTable range={range} />
      </div>
    </>
  )
}
